const AMSTERDAM = "Europe/Amsterdam";

export function amsterdamToday() {
  return new Date().toLocaleDateString("en-CA", { timeZone: AMSTERDAM });
}

/** Default as-of date for local testing without realtime data. */
export function defaultWallboardDate() {
  const d = new Date(
    new Date().toLocaleString("en-US", { timeZone: AMSTERDAM })
  );
  d.setMonth(d.getMonth() - 1);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function isHistoricalWallboardDate(date) {
  if (!date) return false;
  return String(date).slice(0, 10) !== amsterdamToday();
}

/** Production builds always show live today: no date bar, no ?date= pin. */
export function isLiveWallboard() {
  return process.env.NODE_ENV === "production";
}
